import { useEffect, useState } from 'react';
import { gql, useQuery } from '@apollo/client';
import { CORE_PROPERTY_FIELDS } from '@general/graphql/fragments/property';
import { PROPERTY_CONTACTS_FIELDS } from '@general/graphql/fragments/property-contacts';

export const GET_PROPERTY_QUERY = gql`
    ${CORE_PROPERTY_FIELDS}
    ${PROPERTY_CONTACTS_FIELDS}
    query Property($id: ID!) {
        node(id: $id) {
            ... on Property {
                ...CorePropertyFields
                ...PropertyContactsFields
            }
        }
    }
`;

const useProperty = ({ id, ...options }) => {
    const [property, setProperty] = useState();
    const { data, ...rest } = useQuery(GET_PROPERTY_QUERY, {
        variables: { id },
        ...options,
    });

    useEffect(() => {
        if (!data) {
            return;
        }

        setProperty(data.node);
    }, [data]);

    return { data: property, ...rest };
};

export default useProperty;
